<template>
  <div>
    <a-modal v-model="visible"
      class="mixed-select-box"
      title="搭档选择"
      width="337px"
      height="193px"
      cancelText="取消"
      okText="确定"
      @cancel="handleMixedSelectCancel"
      @ok="handleMixedSelectOk">
      <a-select
        v-if="selectListLength > 0"
        class="mixed-select"
        show-search
        placeholder="选择一位球员"
        option-filter-prop="children"
        style="width: 253px;"
        v-model="mixedPartner"
        :filter-option="MixedSelectFilterOption"
        @change="handleMixedSelectChange">
        <a-select-option
          v-for="player in selectInfo.playerList"
          :key="`mixed-select-${player.player_id}`"
          class="mixed-select-option"
          :value="player.player_id">
          {{player.player_name}}
        </a-select-option>
      </a-select>
    </a-modal>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {
      mixedPartner: '',
      selectListLength: 0,
      visible: false,
    }
  },
  props: {
    'isVisible': {
      type: Boolean,
      default: false,
    },
    'selectInfo': {
      type: Object,
      default: {
        type: 'double',
        playerList: [{player_id:'',player_name:''}],
        playerId: 0,
        competitionId: 0,
      }
    }
  },
  watch: {
    isVisible: { // 对对象进行深度监听
      handler(value) {
        this.mixedPartner = ''
        this.visible = value
      },
      immediate: true,
    },
    selectInfo: {
      handler(value) {
        if(value.playerList) {
          this.selectListLength = value.playerList.length
        }
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    handleMixedSelectOk() {
      this.visible = false
      if(this.mixedPartner !== ''){
        this.$store.commit('setLoading',true)
        this.$emit('changeMixedPartner', {
          'type': this.selectInfo.type,
          'mixedPartner': this.mixedPartner,
        })
      }else{
        this.$store.commit('setLoading',false)
        this.$emit('changeMixedPartner', {
          'type': this.selectInfo.type,
          'mixedPartner': '',
        })
      }
      this.mixedPartner = ''
      this.selectListLength = 0
    },
    handleMixedSelectCancel() {
      this.visible = false
      this.$store.commit('setLoading',false)
      this.$emit('changeMixedPartner', {
        'type': this.selectInfo.type,
        'mixedPartner': '',
      })
      this.mixedPartner = ''
      this.selectListLength = 0
    },
    handleMixedSelectChange(value) {
      this.mixedPartner = value
    },
    MixedSelectFilterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  }
});
</script>
<style lang="less" scoped>

</style>
<style lang="less">
.mixed-select-box{
  .ant-modal {
    position: absolute;
    top: calc(50% - 96.5px);
    left: calc(50% - 168.5px);
  }

  .ant-modal-content {
    height: 193px;
    position: relative;

    .ant-modal-header {
      height: 70px;
      padding: 0px;
      border-bottom: 0px solid white;

      .ant-modal-title {
        height: 70px;
        line-height: 70px;
        font-family: 'Microsoft YaHei UI';
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        text-align: center;
        letter-spacing: -0.015em;
        color: #000000;
      }
    }
    .ant-modal-body {
      height: 70px;
      padding: 0px 42px;

      .ant-select-selection {
        height: 51px;
        background: #FFFFFF;
        border: 1px solid #00375B;
        border-radius: 6px;

        .ant-select-selection__rendered {
          height: 49px;
          line-height: 49px;
          padding-left: 10px;
          font-family: 'Microsoft YaHei UI';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          text-align: center;
          letter-spacing: -0.015em;
          color: #000000;
          position: relative;

          .ant-select-selection-selected-value {
            width: 100%;
          }
        }
      }
    }
    .ant-modal-footer {
      border-top: 0px solid white;

      .ant-btn:hover, .ant-btn:focus {
        color: #0072BE;
        background-color: #fff;
        border-color: #0072BE;
      }
      .ant-btn-primary {
        background-color: #0072BE;
        border-color: #0072BE;
      }
    }
  }
  .ant-select-open {
    .ant-select-selection {
      box-shadow: none;
    }
  }
  .ant-select-focused {
    .ant-select-selection {
      box-shadow: none;
    }
    .ant-select-selection:focus {
      box-shadow: none;
    }
    .ant-select-selection:active {
      box-shadow: none;
    }
  }
}
.mixed-select-option {
  text-align: center;
}
</style>
